export function anchorScroll() {
  const anchorLinks = document.querySelectorAll('a[href*="#"]');
  const headerHeight = document.querySelector('.l-header').offsetHeight;

  anchorLinks.forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      const href = anchor.getAttribute('href');
      const hashIndex = href.indexOf('#');
      const targetId = href.substring(hashIndex);

      if (window.location.href.split('#')[0] === anchor.href.split('#')[0]) {
        e.preventDefault();

        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }
    });
  });

  // Adjust scroll position on page load if there's a hash
  window.addEventListener('load', function() {
    const hash = window.location.hash;
    if (hash) {
      const targetElement = document.querySelector(hash);
      if (targetElement) {
        const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  });
}
